module.exports = __webpack_public_path__ + "static/media/anna-4row.95aaf4ea.png";